import { useEffect, useState } from 'react';
import './WorkshopModal.css';

export default function WorkshopModal({ workshop, onClose }) {
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [preloadedImages, setPreloadedImages] = useState({});

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        if (lightboxIndex !== null) {
          setLightboxIndex(null);
        } else {
          onClose();
        }
      } else if (lightboxIndex !== null) {
        if (e.key === 'ArrowRight') {
          setLightboxIndex((prev) => (prev + 1) % workshop.gallery.length);
        } else if (e.key === 'ArrowLeft') {
          setLightboxIndex(
            (prev) =>
              (prev - 1 + workshop.gallery.length) % workshop.gallery.length
          );
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, lightboxIndex, workshop?.gallery?.length]);

  const preloadImage = (index) => {
    if (!preloadedImages[index]) {
      const fullImg = new Image();
      fullImg.src = `${process.env.PUBLIC_URL}/${workshop.gallery[index]}`;
      setPreloadedImages((prev) => ({ ...prev, [index]: true }));
    }
  };

  const openLightbox = (index) => {
    preloadImage(index);
    setLightboxIndex(index);
  };

  const closeLightbox = () => setLightboxIndex(null);

  if (!workshop) return null;

  return (
    <div className='modal-overlay' onClick={onClose}>
      <div className='modal-content' onClick={(e) => e.stopPropagation()}>
        <button className='modal-close' onClick={onClose}>
          &times;
        </button>

        <div className='top-container'>
          <img
            src={`${process.env.PUBLIC_URL}/${workshop.marker}`}
            alt='znacznik'
            className='workshop-marker-inner-modal display-desktop'
          />
          <div>
            {workshop.specialization && (
              <h4 className='text-specialization-inner-modal'>
                {workshop.specialization}
              </h4>
            )}{' '}
            {workshop.name2 && <span>/ {workshop.name2} </span>}
            <h2 className='text-name-inner-modal'>{workshop.name}</h2>
          </div>
        </div>

        <div className='data-container'>
          <div className='data-container-left'>
            <div className='data-container-left-top'>
              <img
                src={`${process.env.PUBLIC_URL}/${workshop.marker}`}
                alt='znacznik'
                className='workshop-marker-inner-modal display-mobile'
              />
              <div className='modal-info-icons display-desktop'>
                {workshop.disabled && (
                  <img
                    className='ikona-modal-2'
                    src={`${process.env.PUBLIC_URL}/img/niepelnosprawni.svg`}
                    alt='Udogodnienia'
                    title='Dostępność dla osób z niepełnosprawnością'
                  />
                )}
                {workshop.accommodation && (
                  <img
                    className='ikona-modal'
                    src={`${process.env.PUBLIC_URL}/img/nocleg.svg`}
                    alt='Nocleg'
                    title='Możliwość noclegu'
                  />
                )}
              </div>

              <div className='modal-text'>
                {workshop.adress && (
                  <p>
                    {workshop.id >= 1 && workshop.id <= 8 ? (
                      <>
                        ADRES W DNIACH 11–13.07.2025:
                        <br />
                        <div
                          dangerouslySetInnerHTML={{
                            __html: workshop.adress,
                          }}
                        />
                      </>
                    ) : (
                      <>
                        ADRES:
                        <br />
                        <div
                          dangerouslySetInnerHTML={{
                            __html: workshop.adress,
                          }}
                        />
                      </>
                    )}
                  </p>
                )}
              </div>
            </div>

            <div className='modal-info-icons display-mobile'>
              {workshop.disabled && (
                <img
                  className='ikona-modal-2'
                  src={`${process.env.PUBLIC_URL}/img/niepelnosprawni.svg`}
                  alt='Udogodnienia'
                  title='Dostępność dla osób z niepełnosprawnością'
                />
              )}
              {workshop.accommodation && (
                <img
                  className='ikona-modal'
                  src={`${process.env.PUBLIC_URL}/img/nocleg.svg`}
                  alt='Nocleg'
                  title='Możliwość noclegu'
                />
              )}
            </div>

            {workshop.hours && (
              <div className='hours-info'>
                <img className='ikona-modal' src='./img/zegar.svg' />
                <span>{workshop.hours}</span>
              </div>
            )}
          </div>
          <div className='data-info'>
            {workshop.tel && (
              <div>
                <img
                  className='ikona-modal'
                  src='./img/ikona-tel.svg'
                  alt='Telefon'
                />
                <a href={`tel:+48${workshop.tel}`}>
                  {workshop.tel.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')}
                </a>
              </div>
            )}

            {workshop.mail && (
              <div>
                <img
                  className='ikona-modal'
                  src='./img/ikona-mail.svg'
                  alt='E-mail'
                />
                <a href={`mailto:${workshop.mail}`}>{workshop.mail}</a>
              </div>
            )}

            {workshop.mail2 && (
              <div>
                <img
                  className='ikona-modal'
                  src='./img/ikona-mail.svg'
                  alt='E-mail'
                />
                <a href={`mailto:${workshop.mail2}`}>{workshop.mail2}</a>
              </div>
            )}

            {workshop.fb && (
              <div>
                <img className='ikona-modal' src='./img/ikona-fb.svg' />
                <a
                  href={`https://facebook.com/${workshop.fb}`}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {workshop.fb}
                </a>
              </div>
            )}

            {workshop.fb2 && (
              <div>
                <img className='ikona-modal' src='./img/ikona-fb.svg' />
                <a
                  href={`https://facebook.com/${workshop.fb2}`}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {workshop.fb2}
                </a>
              </div>
            )}

            {workshop.ig && (
              <div>
                <img className='ikona-modal' src='./img/ikona-ig.svg' />
                <a
                  href={`https://instagram.com/${workshop.ig}`}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {workshop.ig}
                </a>
              </div>
            )}

            {workshop.ig2 && (
              <div>
                <img className='ikona-modal' src='./img/ikona-ig.svg' />
                <a
                  href={`https://instagram.com/${workshop.ig2}`}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {workshop.ig2}
                </a>
              </div>
            )}

            {workshop.site && (
              <div>
                <img className='ikona-modal' src='./img/ikona-site.svg' />
                <a
                  href={`https://${workshop.site}`}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {workshop.site}
                </a>
              </div>
            )}

            {workshop.site2 && (
              <div>
                <img className='ikona-modal' src='./img/ikona-site.svg' />
                <a
                  href={`https://${workshop.site2}`}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {workshop.site2}
                </a>
              </div>
            )}
          </div>
        </div>
        <div className='bottom-container'>
          {workshop.info && (
            <div
              dangerouslySetInnerHTML={{ __html: workshop.info }}
              className='workshop-info'
            ></div>
          )}

          <img
            src={`${process.env.PUBLIC_URL}/${workshop.image}`}
            alt={workshop.name}
            className='modal-img'
          />
        </div>
        <div>
          {workshop.gallery && workshop.gallery.length > 0 && (
            <div className='modal-gallery'>
              {workshop.gallery.map((fullImagePath, index) => {
                const thumbPath = workshop.galleryMin?.[index] || fullImagePath;
                return (
                  <div className='img-container'>
                    <img
                      key={index}
                      src={`${process.env.PUBLIC_URL}/${thumbPath}`}
                      alt={`${workshop.name} zdjęcie ${index + 1}`}
                      className='modal-gallery-img'
                      loading='lazy'
                      onClick={() => openLightbox(index)}
                      onMouseEnter={() => preloadImage(index)}
                      onFocus={() => preloadImage(index)}
                    />
                  </div>
                );
              })}
            </div>
          )}

          {lightboxIndex !== null && (
            <div className='lightbox' onClick={closeLightbox}>
              <span className='lightbox-close'>&times;</span>

              <button
                className='lightbox-prev'
                onClick={(e) => {
                  e.stopPropagation();
                  setLightboxIndex(
                    (prev) =>
                      (prev - 1 + workshop.gallery.length) %
                      workshop.gallery.length
                  );
                }}
              >
                &#10094;
              </button>

              <img
                src={`${process.env.PUBLIC_URL}/${workshop.gallery[lightboxIndex]}`}
                alt={`Zdjęcie ${lightboxIndex + 1}`}
                className='lightbox-img'
                onClick={(e) => e.stopPropagation()}
              />

              <button
                className='lightbox-next'
                onClick={(e) => {
                  e.stopPropagation();
                  setLightboxIndex(
                    (prev) => (prev + 1) % workshop.gallery.length
                  );
                }}
              >
                &#10095;
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
